/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/styles/sections/opk-product-details.scss":
/*!******************************************************!*\
  !*** ./src/styles/sections/opk-product-details.scss ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://Cejor/./src/styles/sections/opk-product-details.scss?");

/***/ }),

/***/ "./src/scripts/sections/opk-product-details.js":
/*!*****************************************************!*\
  !*** ./src/scripts/sections/opk-product-details.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_opk_product_details_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/opk-product-details.scss */ \"./src/styles/sections/opk-product-details.scss\");\n\nconst descriptionWrapper = document.querySelector('[id*=\"description\"]');\nconst descriptionContainer = descriptionWrapper.querySelector('.product');\nconst description = descriptionWrapper.querySelector('.content-block');\nconst descriptionHeight = description ? description.offsetHeight : '';\nconst trimDescription = () => {\n  const trimButton = document.createElement('div');\n  trimButton.textContent = 'Lees meer';\n  trimButton.className = 'content-block trim-button';\n  description.classList.add('trim');\n  descriptionContainer.appendChild(trimButton);\n  trimButton.addEventListener('click', () => {\n    if (description.classList.contains('trim')) {\n      description.classList.remove('trim');\n      descriptionWrapper.style.height = descriptionHeight + 55 + 'px';\n      trimButton.textContent = 'Oprollen';\n    } else {\n      description.classList.add('trim');\n      descriptionWrapper.style.height = 'fit-content';\n      trimButton.textContent = 'Lees meer';\n    }\n  });\n};\ndocument.addEventListener(\"DOMContentLoaded\", () => {\n  if (description) trimDescription();\n});\n\n//# sourceURL=webpack://Cejor/./src/scripts/sections/opk-product-details.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/opk-product-details.js");
/******/ 	
/******/ })()
;